import { useState } from 'react';
import { useEntityVersions } from '../../../loaders/useEntityVersions';
import { IEntityVersionSearchParams } from '../../../api/requests/entities/entityVersionApiGateway';
import { useEntitiesCount } from './useEntitiesCount';

interface PropTypes {
    defaultPageSize: number,
    refresh: boolean
}

export const EntitiesSearchLocalStorageKey = 'EntitiesSearchPageNumber';
export const EntitiesPerPageKey = 'EntitiesPerPage';

export const useEntitiesSearch = (props: PropTypes) => {

    const [query, setQuery] = useState<IEntityVersionSearchParams>({
        pageSize: props.defaultPageSize,
        pageNumber: parseInt(window.localStorage.getItem(EntitiesSearchLocalStorageKey) ?? '1')
    });

    const loadEntitiesResult = useEntityVersions(props.refresh, query);
    const entitiesCountResult = useEntitiesCount(query);

    const setPageNumber = (pageNumber: number) => {
        window.localStorage.setItem(EntitiesSearchLocalStorageKey, pageNumber.toString());
        setQuery({ ...query, pageNumber: pageNumber });
    };

    const setPageSize = (pageSize: number) => {
        window.localStorage.setItem(EntitiesPerPageKey, pageSize.toString());
        setQuery({ ...query, pageSize: pageSize, pageNumber: 1 });
    };

    return {
        query,
        loadEntitiesResult,
        entitiesCountResult,
        setPageNumber,
        setPageSize
    };
};
